import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'
import storage from '../../services/stoage.service'
import { messageActions } from '../../store/message'
import { setUnidadeCorrente } from '../../store/app/app.actions'

const BASE_PATH = "/lottustech/empresas";
const BASE_PATH_UNIDADE = "/lottustech/unidades";
const BASE_PATH_NFSE = "/lottustech/notasfiscaisservico";
const prefix = "crudEmpresa";
const crud = build(validate, BASE_PATH);

const newTypes = {
  SET_LOOKUP_PESSOA_VISIBLE: `${prefix}setLookupPessoaVisible`,
  RESET: `${prefix}reset`
};

const actions = new Action(prefix, crud);

const types = Object.assign({}, actions.types, newTypes);

actions.reset = () => {
  return {
    type: types.RESET
  };
};

actions.setLookupPessoaVisible = visible => {
  return {
    type: types.SET_LOOKUP_PESSOA_VISIBLE,
    visible
  };
};

actions.loadConfiguracoes = () => {
  return (dispatch) => {

    const company = storage.getCompany();
    // PHOENIX-963: unidades que emitem NFSe pela regra do BE (chave da Inventti ou emissor nacional). Carrega a parte
    // dos parametros para quem ja esta logado receber no proximo carregamento. Se falhar (ex.: BE ainda sem o
    // endpoint), nao grava - o botao NFS-e segue so a chave da Inventti e tenta de novo no proximo carregamento.
    if (company && !Array.isArray(company.unidadesEmitemNfse)) {
      api
        .get(`${BASE_PATH_NFSE}/unidadesEmitemNfse`)
        .then((response) => {
          company.unidadesEmitemNfse = Array.isArray(response.data) ? response.data : []
          storage.setCompany(company)
        })
        .catch(() => {})
    }
    if (company && (company.parametros === undefined || company.parametros === null || company.parametros.length === 0)) {
      api
        .get(`${BASE_PATH}/${company.oid}/parametros`)
        .then((response) => {
          company.parametros = response.data || []

          if (company.unidades.length > 0) {
            const promises = company.unidades
              .filter(unidade => unidade.parametros === undefined || unidade.parametros === null || unidade.parametros.length === 0)
              .map(unidade =>
                api
                  .get(`${BASE_PATH_UNIDADE}/${unidade.oid}/parametros`)
                  .then((response) => {
                    unidade.parametros = response.data || []
                  })
                  .catch((err) => {
                    if (err.response) {
                      const messages = err.response.data
                      dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
                    }
                  })
              )
            Promise.all(promises).then(() => {
              storage.setCompany(company)
            })
          } else {
            storage.setCompany(company)
          }
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

actions.loadConfiguracoesUnidade = () => {
  return (dispatch) => {
    const unit = storage.getUnit()
    if (unit && (unit.parametros === undefined || unit.parametros === null || unit.parametros.length === 0)) {
      api
        .get(`${BASE_PATH_UNIDADE}/${unit.oid}/parametros`)
        .then((response) => {
          unit.parametros = response.data || []
          storage.setUnit(unit)
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })

    }
  }
}

const makeMessages = (messages, type, keepOpen = false) => {
  return messages.map((message) => {
    return {
      sticky: keepOpen ? true : type === 'error',
      life: type === 'error' ? 20000 : 5000,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions };
